import BaseService from "../../base/base_service";
import ISafezoneLoaderService, {SafezoneLoaderServiceInitParams} from "./safezone_loader_service_interface";
import _ from "../../utils/underscore";

class SafezoneLoaderService extends BaseService implements ISafezoneLoaderService {
  static CLASS: string = 'SafezoneLoaderService';
  private sdkUrl:string = null;

  init(params:SafezoneLoaderServiceInitParams):void {
      super.init(params);
      if(_.isNullOrUndefined(params.sdkUrl)) {
        this.throwError('12',`${this.getClassName()} expects parameter sdkUrl which was not supplied`, {params});
      }
      this.sdkUrl = params.sdkUrl;
  }

  public loadSafezoneSdk():Promise<void>{
    return this.serviceFactory.scriptLoaderService().loadScript(this.sdkUrl, "safezonelibrary");
  }
}
export default SafezoneLoaderService;